import { createFetch } from 'ext/lib/api/fetch-client';
import type { ApiClient } from 'ext/lib/api/types';

interface AuthConfig {
  accountId: string;
  /** Token can be a static string or a function that returns a fresh token */
  token: string | (() => Promise<string> | string);
}

export interface DashboardApiOptions {
  /** Override for Appcues API base URL */
  appcuesApiUrl?: string | undefined;
}

export const getDashboardApiEndpoints = (
  auth: AuthConfig,
  options: DashboardApiOptions = {}
): Partial<ApiClient> => {
  const appcuesApiUrl =
    options.appcuesApiUrl ?? import.meta.env.APPCUES_API_URL;

  const fetchDashboardAPI = createFetch(`${appcuesApiUrl}/v1`, auth);

  return {
    getFlowPreview: id => fetchDashboardAPI(`flow_preview/${id}`),

    getUserProperties: () => fetchDashboardAPI('profile_attributes'),

    trackMetric: metric =>
      fetchDashboardAPI(
        'metrics',
        {
          method: 'POST',
          body: JSON.stringify(metric),
        },
        '/'
      ),

    getCompiledExperienceTheme: (themeId: string, platform: string) =>
      fetchDashboardAPI(`experience_themes/${themeId}/${platform}`),
  };
};
